import { Component } from '@angular/core';
import {
    DatabaseService,
    ParametersService,
    SubtitlesService,
    ViewsService, ZoneScheduleService,
    ZonesService
} from "../../core";
import {StateService} from "@uirouter/core";
import {ZoneSchedule} from "../../models";

@Component({
    selector: 'zone-schedule',
    templateUrl: './zone-schedule.component.html',
    styleUrls: ['./zone-schedule.component.scss']
})
export class ZoneScheduleComponent {
    constructor(
        public database: DatabaseService,
        private parameters: ParametersService,
        private $state: StateService,
        private subtitles: SubtitlesService,
        public views: ViewsService,
        public zones: ZonesService,
        public zoneSchedule: ZoneScheduleService,
    ) {
    }

    ngOnInit() {
        if (this.zones.selectedZone === undefined) {
            this.$state.go('home', {selectedModuleHash: this.parameters.selectedModuleHash});
            return;
        }

        this.zones.setOverflow();
    }

    subtitle(id: number) {
        return this.subtitles.setSubtitle(id);
    }

    get schedules():  ZoneSchedule[] {
        const zones = this.database.zones.getValue();
        return this.database.isZonesDataType(zones) ? zones.globalSchedules.elements : [];
    }
}
